"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const manifest_1 = require("../manifest");
const _appearance_1 = require("./_appearance");
const ICONS = ['bike', 'truck', 'store', 'shield', 'clock', 'gift', 'credit-card', 'leaf', 'heart', 'star', 'tag', 'phone'];
(0, manifest_1.registerSection)({
    type: 'info-strip', label: 'Info strip', icon: 'badge-check', category: 'content',
    settingsSchema: zod_1.z.object({ ..._appearance_1.appearanceShape }),
    blockTypes: { item: { label: 'Item', icon: 'badge-check', max: 6,
            settingsSchema: zod_1.z.object({
                icon: zod_1.z.enum(ICONS).default('shield'),
                title: zod_1.z.string().max(60).default(''),
                subtitle: zod_1.z.string().max(120).default(''),
            }) } },
    maxBlocks: 6,
    defaults: () => ({ ...(0, _appearance_1.appearanceDefaults)() }),
    fields: [..._appearance_1.appearanceFields],
    blockFields: {
        item: [
            { name: 'icon', label: 'Icon', control: 'icon-enum', options: ICONS.map((v) => ({ label: v.replace('-', ' '), value: v })) },
            { name: 'title', label: 'Title', control: 'text' },
            { name: 'subtitle', label: 'Subtitle', control: 'text' },
        ],
    },
});
//# sourceMappingURL=info-strip.js.map